import { IPricePoliciesListPayload, IPricePoliciesListResponse } from '../../Services/api/price-policies/price-policies.interface'
import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListPricePoliciesUseCase
implements IFormUsecase<IPricePoliciesListPayload, IPricePoliciesListResponse> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    

  public async handle (
    data: IPricePoliciesListPayload
  ): Promise<Result<IPricePoliciesListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.PricePoliciesApi.list(data)

      if (response.isFailure) {
        return response
      }

      const list = response.getValue()

      if(!list) return response

    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
